import { Component, Input, Output, EventEmitter, AfterViewInit, ViewChild, HostListener } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';

import { ExcelService } from './../../../services/infrastructure/excel.service';
import { tableHeader, eventDetail } from '../../../models/AccountDetailsVM';
import { CellDataType } from './grid-view-enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gridview',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.scss']
})

export class gridViewComponent implements AfterViewInit {
  headerDS: any[] = [];
  customAction: any[] = [];
  bodyDS: any[] = [];
  paginatorDS: any[] = [];
  @ViewChild('placedOrdersTable', { read: MatSort }) placedCPPOrdersSort: MatSort;
  @ViewChild('placedOrdersPaginator', { read: MatPaginator }) placedCPPOrdersPaginator: MatPaginator;
  headerList: any[] = [];
  cellDataType = CellDataType;
  @Input() isReadOnlyAccess: boolean;
  @Input() isCreateButton: boolean;
  @Input() CreateButtonTitle: string;
  @Input() isPaginatorRequired: boolean;

  // MatPaginator Inputs
  length = 0;
  pageSize = 50;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  constructor(public excelService: ExcelService,
    private router: Router) {
  }

  // set and get input field for header
  @Input()
  set propHeaderDS(headers: tableHeader[]) {
    this.headerDS = headers;
  }
  get propHeaderDS(): tableHeader[] {
    return this.headerDS;
  }
  // set and get input field for table data source
  @Input()
  set propBodyDS(dataList: any[]) {
    this.bodyDS = dataList;
    if (this.bodyDS) {
      this.length = this.bodyDS.length;
      this.setPaginatorDS();
    }
  }
  get propBodyDS(): any[] {
    return this.bodyDS;
  }

  @Input()
  set headerListValue(val: any) {
    this.headerList = val;
  }

  @Output()
  ActionPerformed: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  @Output()
  CreateClicked: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  @Output()
  UpdateClicked: EventEmitter<eventDetail> = new EventEmitter<eventDetail>();

  // set paginator on change
  setPaginatorDS() {
    if (this.isPaginatorRequired) {
      const recordToSkip = this.pageSize * this.pageIndex;
      this.paginatorDS = this.bodyDS.slice(recordToSkip, recordToSkip + this.pageSize);
    }
    else {
      this.paginatorDS = this.bodyDS;
    }
  }

  // set MatPaginator Inputs on paginator change
  onPaginatorChange(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.setPaginatorDS();
  }

  sortData(sort: Sort) {
    const data = this.bodyDS.slice();

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.bodyDS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return compare(a[sort.active], b[sort.active], isAsc);
    });

    this.setPaginatorDS();
  }

  onActionPerformed(e: any, rowData: any, actionName: any) {
    const eventData = new eventDetail();
    eventData.event = actionName;
    eventData.eventData = e;
    eventData.rowData = rowData;
    this.ActionPerformed.emit(eventData);
  }

  onCretePerformed(e: any) {
    const eventData = new eventDetail();
    eventData.event = 'CreateClicked';
    eventData.eventData = e;
    this.CreateClicked.emit(eventData);
  }

  onUpdatePerformed(e: any, rowData: any) {
    const eventData = new eventDetail();
    eventData.event = 'UpdateClicked';
    eventData.eventData = e;
    eventData.rowData = rowData;
    this.UpdateClicked.emit(eventData);
  }
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Set Account Table Height
  setAccountTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.accountPageTopFilter').outerHeight() - $('.tableTopSec').outerHeight() - 220;
      $('.tableComponentOuter').css('max-height', tableHeight + 'px');
    }, 100);
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
